import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';
import AreaStaticChip from '@ifeng-fe/container_content/common/client/components/areaStaticChip';
import styles from './index.css';
import Artical from './artical';
import Info from './info';

class LeftContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const {
            type,
            allowComment,
            joinNum,
            count,
            article,
            chipObj,
            contentBottomAd,
            infoAd,
            hardAd,
            hasCopyRight,
            faceUrl,
            vestAccountDetail,
            subscribe,
            keywords,
            interact,
            sourceReason,
            isHubeiLocal,
        } = content;

        const commentInfo = {
            allowComment,
            joinNum,
            count,
        };

        // 佛教无为您推荐内容
        return (
            <div className={styles.leftContent}>
                <Artical
                    type={type}
                    commentInfo={commentInfo}
                    content={article}
                    chipObj={chipObj}
                    contentBottomAd={contentBottomAd}
                    hasCopyRight={hasCopyRight}
                    faceUrl={faceUrl}
                    vestAccountDetail={vestAccountDetail}
                    subscribe={subscribe}
                    keywords={keywords}
                    interact={interact}
                    sourceReason={sourceReason}
                    isHubeiLocal={isHubeiLocal}
                />
                <Chip
                    id={chipObj.infoAd}
                    type="recommend"
                    title="网罗天下"
                    groupName="评论下方"
                    translate="handleInfoAd"
                    content={infoAd}>
                    <Info />
                </Chip>
                <NoSSR>
                    <Chip
                        id={chipObj.hardAd}
                        type="static"
                        title="评论下方广告"
                        groupName="评论下方"
                        translate="handleAreaAd"
                        content={hardAd}>
                        <AreaStaticChip styleName={hardAd ? styles.chip_box : styles.chip_ebox} />
                    </Chip>
                </NoSSR>
            </div>
        );
    }
}

export default errorBoundary(LeftContent);
